import React, { useState, useMemo } from 'react';
import classNames from 'classnames/bind';
import styles from './AdvertisementPlay.module.scss';

const cx = classNames.bind(styles);

export default function AdvertisementPlay() {
  return <div id="ad-container" className={cx('container')}></div>;
}
